module.exports = __webpack_public_path__ + "files/2cfff6bd2cd6761e997a436f696f5bdc.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/smart_dark.png
// module id = 936
// module chunks = 76